// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paper-vIaJP";
var _4 = "modalX__root-1KGx4";
var _5 = "content-3oF_C";
var _6 = "serviceName-2VPYE";
var _7 = "serviceDescription-27ZT0";
var _8 = "heading-38xx4";
var _9 = "date-1KFXa";
var _a = "cost-14fNt";
var _b = "city-2gbkN";
var _c = "passenger-2nPXZ";
var _d = "checkbox-1fm6D";
var _e = "passengerNumber-1YkF5";
var _f = "passengerName-N5EYN";
var _10 = "passengerPrice-s920E";
var _11 = "footer-4TSB-";
var _12 = "confirm-2NEVe";
var _13 = "cancel-2T4zB";
var _14 = "clear-3a3Ov";
var _15 = "total-3ajMV";
var _16 = "price-3uZy0";
var _17 = "divider-Z0fcF";
var _18 = "footerControls-e7hvw";
export { _1 as "__esModule", _2 as "mobile", _3 as "paper", _4 as "modalX__root", _5 as "content", _6 as "serviceName", _7 as "serviceDescription", _8 as "heading", _9 as "date", _a as "cost", _b as "city", _c as "passenger", _d as "checkbox", _e as "passengerNumber", _f as "passengerName", _10 as "passengerPrice", _11 as "footer", _12 as "confirm", _13 as "cancel", _14 as "clear", _15 as "total", _16 as "price", _17 as "divider", _18 as "footerControls" }
export default { "__esModule": _1, "mobile": _2, "paper": _3, "modalX__root": _4, "content": _5, "serviceName": _6, "serviceDescription": _7, "heading": _8, "date": _9, "cost": _a, "city": _b, "passenger": _c, "checkbox": _d, "passengerNumber": _e, "passengerName": _f, "passengerPrice": _10, "footer": _11, "confirm": _12, "cancel": _13, "clear": _14, "total": _15, "price": _16, "divider": _17, "footerControls": _18 }
